export const SC_PRIMARY_COLOR = '#1D4F7E'
export const SC_DEFAULT_REFRESH_INTERVAL = 15 // seconds
export const SC_DEFAULT_HEIGHT_ROW = 45
export const SC_DEFAULT_BORDER_ROW = 1
export const SC_DEFAULT_ROW_SPACING = 5
export const SEX_COLOR_MALE = '#2971B3'
export const SEX_COLOR_FEMALE = '#FF85D1'
export const DEFAULT_ANIMATION_TEXT_SIZE_SMALL = 150
export const DEFAULT_ANIMATION_TEXT_SIZE_MEDIUM = 225
export const DEFAULT_ANIMATION_TEXT_SIZE_LARGE = 300
export const CANCELLED_ICON_COLOR = '#9E9E9E'
export const PRINT_MARGIN = 10
export const PAGE_A4_HEIGHT = 790
export const PAGE_PRINT_HEIGHT = 100
export const HEADER_SIZE = 84
